// Location: src/components/admin/schedule/ScheduleStatusInfo.tsx
// Purpose: Display current and last run status messages
// Scope: Shows status messages in a styled box

import React from 'react';
import { Schedule } from '@/types/schedules';

interface ScheduleStatusInfoProps {
	schedule: Schedule;
}

export const ScheduleStatusInfo = React.memo(function ScheduleStatusInfo({
	schedule,
}: ScheduleStatusInfoProps) {
	const uploadPostDetails = [
		{
			label: 'Request',
			value:
				schedule.metadata?.uploadPostRequestId ||
				schedule.metadata?.requestId ||
				schedule.metadata?.uploadPost?.requestId,
		},
		{
			label: 'Job',
			value:
				schedule.metadata?.uploadPostJobId ||
				schedule.metadata?.jobId ||
				schedule.metadata?.uploadPost?.jobId,
		},
		{
			label: 'Provider status',
			value:
				schedule.metadata?.uploadPostStatus ||
				schedule.metadata?.providerStatus ||
				schedule.metadata?.uploadPost?.status,
		},
		{
			label: 'Provider post',
			value:
				schedule.metadata?.providerPostId ||
				schedule.metadata?.uploadPost?.providerPostId,
		},
	].filter((detail) => detail.value);

	return (
		<div className='mt-6 p-4 rounded-lg bg-gray-100/50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-800'>
			<div className='text-muted-foreground dark:text-muted-foreground/70'>
				{/* Current Status */}
				{schedule.lastStatus && (
					<div className='flex items-start gap-2 mb-2'>
						<span className='mt-1'>ℹ️</span>
						<div>
							<span className='text-lg font-semibold text-purple-600 dark:text-purple-400'>
								{schedule.lastStatus.message ||
									'No status message'}
							</span>
						</div>
					</div>
				)}
				{/* Last Run Status */}
				{schedule.lastRunStatus && (
					<div className='flex items-start gap-2 mt-2'>
						<span className='mt-1'>📝</span>
						<div>
							<span className='text-lg font-semibold text-gray-900 dark:text-white'>
								Last Run:{' '}
							</span>
							<span className='text-lg text-orange-600 dark:text-orange-400'>
								{schedule.lastRunStatus.message ||
									'No run message'}
							</span>
						</div>
					</div>
				)}
				{uploadPostDetails.length > 0 && (
					<div className='mt-4 rounded-md border border-purple-500/20 bg-background/70 p-3'>
						<div className='text-sm font-semibold text-gray-900 dark:text-white'>
							Upload Post status
						</div>
						<div className='mt-2 grid gap-1 text-sm'>
							{uploadPostDetails.map((detail) => (
								<div
									key={detail.label}
									className='flex gap-2'
								>
									<span className='font-medium text-gray-900 dark:text-white'>
										{detail.label}:
									</span>
									<span className='font-mono text-purple-600 dark:text-purple-300'>
										{detail.value}
									</span>
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
});
